export default __webpack_public_path__ + "static/media/shareblue.4bb85be1.svg";